module.exports = __webpack_public_path__ + "static/media/billing-ico-grey.4182153d.svg";